/**
 * @generated SignedSource<<2c7106eb91d5bd740fcf6740bbb40482>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArchivedTeamsQuery$variables = Record<PropertyKey, never>;
export type ArchivedTeamsQuery$data = {
  readonly store: {
    readonly allTeams: ReadonlyArray<{
      readonly id: string;
      readonly isArchived: boolean;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team">;
    }>;
  };
};
export type ArchivedTeamsQuery = {
  response: ArchivedTeamsQuery$data;
  variables: ArchivedTeamsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "includeArchived",
    "value": true
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchivedTeamsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "allTeams",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamIconCircleComponent_Team"
              }
            ],
            "storageKey": "allTeams(includeArchived:true)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ArchivedTeamsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "allTeams",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": "allTeams(includeArchived:true)"
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d4a62fec7e7f56ace9178f146478e4d4",
    "id": null,
    "metadata": {},
    "name": "ArchivedTeamsQuery",
    "operationKind": "query",
    "text": "query ArchivedTeamsQuery {\n  store {\n    allTeams(includeArchived: true) {\n      id\n      isArchived\n      name\n      ...TeamIconCircleComponent_Team\n    }\n    id\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n"
  }
};
})();

(node as any).hash = "e870f1eee07a366499488434ce56c89f";

export default node;
